<template>
  <div class="step-title">
    {{ name ? `${name} ` : '' }}
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'StepTitle',
  props: {
    name: String,
  },
};
</script>
<style lang="scss" scoped>
.step-title {
  color: #000;
  font-size: 42px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 1.4;
  text-align: center;

  @media print, screen and (max-width: 400px) {
    font-size: 26px;
  }
}
</style>
